<div class="AMNeedChairModal bg-am-medium-blue text-am-white">
  <div class="AMNeedChairModal-header">
    <img src="assets/images/close.svg" alt="close" (click)="onClose()">
  </div>
  <div class="AMNeedChairModal-content">
    <img src="./assets/images/information/chair.svg" alt="boardin passes" class="size-img">
    <p class="title">{{ 'modalSsrChair.title' | translate }}</p>
    <p class="subTitle">{{ 'modalSsrChair.subTitle' | translate }}</p>
    <div class="content-information" *ngIf="passengers?.length >= 1">
      <p class="title">{{ 'modalSsrChair.information' | translate }}</p>
      <div class="content-passengers">
        <p class="name-passenger" *ngFor="let passenger of passengers">{{passenger.displayName | capitalize}}</p>
      </div>
    </div>
  </div>
</div>
